import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import Expand from './Expand';
import ListItem from './ListItem';
import { withRouter } from '~/hocs/router';
import { actionDockSetExpandLeads } from '@/modules/application/actions/dock';

function getOffers(cfgOffers) {
    return cfgOffers.filter((cfgOffer) => cfgOffer.show_in_leads_menu);
}

const Leads = (props) => {
    const getOfferName = () => props.router.urlSearchParams.get('offer_name');

    return (
        <>
            <ListItem title="Лиды" to="/leads/">
                <Expand expand={props.expand} setExpand={props.setExpand}/>
            </ListItem>
            <Collapse in={props.expand}>
                <List disablePadding={true}>
                    {getOffers(props.cfgOffers).map((cfgOffer, id) => (
                        <ListItem key={id} title={cfgOffer.offer_name}
                                  to={`/leads/?offer_name=${cfgOffer.offer_name}&page=1`}
                                  activeClassName={(cfgOffer.offer_name === getOfferName()) ? 'Mui-selected' : ''}
                        />
                    ))}
                </List>
            </Collapse>
        </>
    );
};

let Component = Leads;
Component = withRouter(Component);

export default connect(
    (state) => ({
        expand: state.dock.expandLeads,
        cfgOffers: state.cfg.offers,
    }),
    (dispatch) => ({
        setExpand: bindActionCreators(actionDockSetExpandLeads, dispatch),
    }),
)(Component);
